import React, { useContext } from 'react';
import { w3cwebsocket } from 'websocket';

import * as Env from 'widget/env';

interface ChatBodyContext {
  accessToken: string | null | undefined;
  isDragAccept: boolean;
  quotedMessage: Env.QuotedMessage | undefined;
  sendMsg: Env.SendMesssage;
  sendReaction: Env.SendReaction;
  setAccessToken: Env.SetState<string | null | undefined>;
  setQuotedMessage: Env.SetState<Env.QuotedMessage | undefined>;
  ws: React.MutableRefObject<w3cwebsocket | null>;
}

const ChatBodyContext = React.createContext<ChatBodyContext>(
  {} as ChatBodyContext,
);

export const useChatBodyContext = () => useContext(ChatBodyContext);
export default ChatBodyContext;
